import ShadowSelectableButton from "ui/components/Button/ShadowSelectableButton";

function DiaItem({
  children,
  selected,
  onClick,
}: {
  children: string;
  selected: boolean;
  onClick: any;
}) {
  return (
    <ShadowSelectableButton
      color="gray.700"
      px={0}
      flex={1}
      selected={selected}
      onClick={onClick}
    >
      {children}
    </ShadowSelectableButton>
  );
}

export default DiaItem;
